class ScrollSpy {
	constructor({ menu, container, activeClass = 'active' }) {
		this.menu = document.querySelector(menu);
		this.container = document.querySelector(container);
		this.activeClass = activeClass;

		this.sections = [];
		this.links = [];
		this.visible = new Map(); // track visibility %

		if (this.menu && this.container) {
			this.init();
		}
	}

	init() {
		this.getSections();
		this.observeSections();
		this.bindClick();
	}

	getSections() {
		this.links = Array.from(this.menu.querySelectorAll('a[href^="#"]'));

		this.sections = this.links.map(link => {
			const id = link.getAttribute('href');
			if (!id || id === '#') return null;
			return document.querySelector(id);
		}).filter(Boolean);
	}

	observeSections() {
		const observer = new IntersectionObserver((entries) => {

			entries.forEach(entry => {
				if (entry.isIntersecting) {
					this.visible.set(entry.target.id, entry.intersectionRatio);
				} else {
					this.visible.delete(entry.target.id);
				}
			});

			this.updateActive();

		}, {
			root: null,
			rootMargin: "0px 0px -50% 0px",
			threshold: 0.3
		});

		this.sections.forEach(section => observer.observe(section));
	}

	// smoother detection
	buildThresholdList() {
		let thresholds = [];
		for (let i = 0; i <= 1.0; i += 0.05) {
			thresholds.push(i);
		}
		return thresholds;
	}

	updateActive() {

		// Always remove first
		this.links.forEach(link => link.classList.remove(this.activeClass));

		this.menu.querySelectorAll('.dropdown').forEach(drop =>
			drop.classList.remove(this.activeClass)
		);

		if (this.visible.size === 0) {
			return; // nothing active anymore
		}

		// find most visible section
		let topId = null;
		let max = 0;

		this.visible.forEach((ratio, id) => {
			if (ratio > max) {
				max = ratio;
				topId = id;
			}
		});

		if (!topId) return;

		const activeLink = this.menu.querySelector(`a[href="#${topId}"]`);
		if (!activeLink) return;

		activeLink.classList.add(this.activeClass);

		// highlight dropdown parent if inside one
		const dropdown = activeLink.closest('.dropdown');

		if (dropdown) {

			dropdown.classList.add(this.activeClass);
		}
	}

	bindClick() {
		this.links.forEach(link => {
			link.addEventListener('click', (event) => {
				event.preventDefault();
				const targetId = link.getAttribute('href');
				if (!targetId || targetId === '#') return;

				const el = document.querySelector(targetId);
				if (!el) return;

				el.scrollIntoView({ behavior: 'smooth', block: 'start' });
			});
		});
	}
}

export default ScrollSpy;
